import MarketplaceWidgetResource from "./MarketplaceWidgetResource";

export { MarketplaceWidgetResource };
